
import React from 'react';

import {Helmet} from 'views/module';

import PlaybooksScene from 'views/scenes/playbooks/Playbooks';

const PlaybooksPage = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Playbooks</title>
      </Helmet>
      <PlaybooksScene
      />
    </>
  );
};

export default PlaybooksPage;
